export * from './paper-sets.module';

/**
 * Exporting this component
 */
export { PaperSetsComponent } from './components/paper-sets.component';
export { PaperSetComponent } from './components/paper-set.component';
export { MainComponent } from './components/main.component';
export { PapersComponent } from './components/papers.component';
export { PaperPartsComponent } from './components/paper-parts.component';
export { PaperComponent } from './components/paper.component';


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-sets/index.ts